import { AnimatePresence, motion } from 'framer-motion';
import React, { FC } from 'react';

import HorizontalScroll from '@/components/Layout/Header/Search/Suggestions/HorizontalScroll';
import School from '@/components/Layout/Header/Search/Suggestions/School';

import { ISchool } from '@/types/schools';

interface Props {
  schools?: ISchool[];
  onClickBook?: () => void;
}

const SchoolCarousel: FC<Props> = ({ schools, onClickBook }) => {
  return (
    <HorizontalScroll scrollAmount={250} className='sm:gap-3 gap-2'>
      <AnimatePresence mode='popLayout'>
        {schools?.map((school, index) => (
          <motion.div
            key={school.id}
            layout
            initial={{ opacity: 0, y: 8 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -8 }}
            transition={{ duration: 0.25 }}
          >
            <School onClickBook={onClickBook} school={school} key={index} />
          </motion.div>
        ))}
      </AnimatePresence>
    </HorizontalScroll>
  );
};

export default SchoolCarousel;
